import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import LoginPage from "./pages/AccountPages/LoginPage.tsx";
import IndexPage from "./pages/IndexPage.tsx";
import Layout from "./components/Layout.tsx";
import RegisterPage from "./pages/AccountPages/RegisterPage.tsx";
import { UserContextProvider } from "./components/UserContext.tsx";
import { StreamChatProvider } from "./components/StreamChatProvider.tsx";
import MessagesPage from "./pages/MessagesPage.tsx";
import AccountPage from "./pages/AccountPages/AccountPage.tsx";
import AboutUsPage from "./pages/AboutUsPage.tsx";
import SolutionsPage from "./pages/SolutionsPage.tsx";
import ListYourWorkspacePage from "./pages/ListYourWorkspace.tsx";
import ContactUsPage from "./pages/ContactUsPage.tsx";
import HelpPage from "./pages/HelpPage.tsx";
import GettingStartedPage from "./pages/HelpPages/GettingStartedPage.tsx";
import FAQPage from "./pages/HelpPages/FAQPage.tsx";
import RetailShopfrontsPage from "./pages/HelpPages/RetailShopfrontsPage.tsx";
import IndustrialWorkshopsPage from "./pages/HelpPages/IndustrialWorkshopsPage.tsx";
import StorageLogisticsPage from "./pages/HelpPages/StorageLogisticsPage.tsx";
import LegalCompliancePage from "./pages/HelpPages/LegalCompliancePage.tsx";
import ContactSupportPage from "./pages/HelpPages/ContactSupportPage.tsx";
import SuggestionsPage from "./pages/SuggestionsPage.tsx";
import TrustAndSafety from "./pages/TrustAndSafety.tsx";
import ReferPage from "./pages/ReferPage.tsx";
import WorkspacePage from "./pages/WorkspacePage.tsx";
import PaymentSuccess from "./pages/PaymentSuccess.tsx";
import PaymentCancel from "./pages/PaymentCancel.tsx";
import Search from "./components/Search.tsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HostResponsibilities from "./pages/HostResponsibilities.tsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";
import TermsOfService from "./pages/TermsOfService.tsx";
import Sitemap from "./pages/Sitemap.tsx";
import CompanyDetails from "./pages/CompanyDetails.tsx";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div style={{ backgroundColor: "var(--background)", minHeight: "100vh" }}>
      <UserContextProvider>
        <StreamChatProvider>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          <Route path="/" element={<><ScrollToTop /><Layout /></>}>
            <Route index element={<IndexPage />} />
            <Route path="/workspaces" element={<Search />} />
            <Route path="/aboutUs" element={<AboutUsPage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/contactUs" element={<ContactUsPage />} />
            <Route path="/workspace/:workspaceId" element={<WorkspacePage />} />
            <Route
              path="/listyourworkspace"
              element={<ListYourWorkspacePage />}
            />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/account/:subpage?" element={<AccountPage />} />
            <Route
              path="/account/:subpage/:action?"
              element={<AccountPage />}
            />
            <Route path="/contact" element={<ContactUsPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route
              path="/help/getting-started"
              element={<GettingStartedPage />}
            />
            <Route path="/help/faq" element={<FAQPage />} />
            <Route
              path="/help/retail-shopfronts"
              element={<RetailShopfrontsPage />}
            />
            <Route
              path="/help/industrial-workshops"
              element={<IndustrialWorkshopsPage />}
            />
            <Route
              path="/help/storage-logistics"
              element={<StorageLogisticsPage />}
            />
            <Route
              path="/help/legal-compliance"
              element={<LegalCompliancePage />}
            />
            <Route
              path="/help/contact-support"
              element={<ContactSupportPage />}
            />
            <Route path="/suggestions" element={<SuggestionsPage />} />
            <Route path="/refer" element={<ReferPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/trust-and-safety" element={<TrustAndSafety />} />
            <Route
              path="/host-responsibilities"
              element={<HostResponsibilities />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/company-details" element={<CompanyDetails />} />
            <Route path="/messages" element={<MessagesPage />} />
          </Route>
        </Routes>
        </StreamChatProvider>
      </UserContextProvider>
    </div>
  );
}

export default App;
